const tyreTypes =
    [
        { value: "Всесезонные", name: "Всесезонные" },
        { value: "Зимние нешипованные", name: "Зимние нешипованные" },
        { value: "Зимние шипованные", name: "Зимние шипованные" },
        { value: "Летние", name: "Летние" },
    ]

export default tyreTypes
